interface LogoMarkProps {
  size?: number;
  className?: string;
}

/** A stamped monogram mark — simple and legible at any size. */
interface LogoMarkProps {
  size?: number;
  className?: string;
}

/** Renders the uploaded logo image at the requested size. */
export default function LogoMark({ size = 28, className = "" }: LogoMarkProps) {
  return (
      <img
          src="/favicon.png"
          width={size}
          height={size}
          className={className}
          alt="Eolass logo"
      />
  );
}